import { openBlock as o, createElementBlock as t, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(m, e) {
  return o(), t("svg", n, [...e[0] || (e[0] = [
    r("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M8 6 5 9m3-3 3 3M8 6v11m7 1 3-3m-3 3-3-3m3 3V7"
    }, null, -1)
  ])]);
}
const d = { render: l };
export {
  d as default,
  l as render
};
